var UTILS = UTILS || Object.create(null);


UTILS.arrayUtils = UTILS.arrayUtils || Object.create(null);
UTILS.arrayUtils.removeFromArray =function(source, toRemove) 
{
    if((source == null) || (toRemove == null))
        return;

    while(toRemove.length > 0)
    {
        var item= toRemove.pop();
        var itemIndex =source.indexOf(item);

        if(itemIndex != -1)
            source = source.splice(itemIndex, 1);
    }

    toRemove = null;
}

UTILS.arrayUtils.clearArray = function(source)
{
    if(source == null)
        return;

    while(source.lenghth > 0)
    {
        source.pop();
    }
}

UTILS.arrayUtils.destroyArray = function(source)
{
    if(source == null)
        return;

    while(source.lenghth > 0)
    {
        var item = source.pop();
        
        if(item.dispose != null)
            item.dispose();
        if(item.destroy != null)
            item.destroy();
    }

    source = null;
}

UTILS.arrayUtils.shuffleArray = function(source, complexityFactor)
{
    if(source == null)
        return;

    if(Number.isNaN(complexityFactor))
        complexityFactor = 100;

    for(var i = 0; i< complexityFactor; i++)
        {
            var item= UTILS.arrayUtils.getRandom(source, true);
            source.push(item);
        }
}

UTILS.arrayUtils.getRandom = function(source, remove)
{
    if((source == null) || (source.lenghth <= 0))
        return null;

    var item = source[Math.floor(Math.random() * source.length)];

    if(remove)
        UTILS.arrayUtils.removeFromArray(source, [item]);

    return item;

}


UTILS.depthSwap = function(visualList) {
       visualList.sort(function(a,b) {
           a.y = a.y || 0;
           b.y = b.y || 0;
           return a.y - b.y;
       });
}



UTILS.objectPools = UTILS.objectPools || Object.create(null);
function Pool(obj, initialCount)
{
    var objPool = [];
    var type = obj;

    while(objPool.length < initialCount)
        {
            var item = new type();
            objPool.push(item);
        }

    this.takeFromPool = function()
    {
        if(objPool.length <= 0)
            {
                return new type();
            }
        else
            {
                return objPool.pop();
            }
    }

    this.returnBatch = function(source, toReturn) 
    {
        if(toReturn == null)
            return;

        while(toReturn.length > 0)
        {
            var item= toReturn.pop();
            if(source != null)
                {
                    var itemIndex =source.indexOf(item);
                    if(itemIndex != -1)
                        source.splice(itemIndex, 1);
                }
            objPool.push(item);
        }

        toReturn = null;
    }

    this.returnToPool = function(item) 
    {
        objPool.push(item);
    }

    this.clearPool = function()
    {
        UTILS.arrayUtils.clearArray(objPool);
    }

    this.destroyPool = function()
    {
         UTILS.arrayUtils.clearArray(destroyArray);
         objPool = null;
         type = null;
    }

}